import { Box, TextField, Tooltip, Typography } from "@mui/material"
import { FIELD_LABEL_SX, PANEL_TEXT } from "@/theme/panelStyles"

const FIELD_INPUT_SX = {
  "& .MuiOutlinedInput-root": { borderRadius: "8px" },
  "& .MuiInputBase-input": {
    fontSize: "13px",
    fontWeight: 600,
    color: PANEL_TEXT,
    py: 0.6,
    px: 1,
  },
  "& .MuiFormHelperText-root": { m: 0, fontSize: "9.5px" },
  // Inherited values (placeholder) look like entered ones.
  "& .MuiInputBase-input::placeholder": { color: PANEL_TEXT, opacity: 1 },
}

// Labeled decimal input in the shared panel look.
export default function DecimalField({
  label,
  tooltip,
  value,
  error,
  onChange,
  helperText,
  inheritedValue,
}) {
  // Empty = inherit: focus fills the inherited value in, leaving it unchanged empties it again.
  const inherited = inheritedValue != null ? String(inheritedValue) : null
  const emit = (next) => onChange({ target: { value: next } })
  const handleFocus = () => {
    if (inherited != null && (value ?? "") === "") emit(inherited)
  }
  const handleBlur = () => {
    if (inherited != null && String(value ?? "") === inherited) emit("")
  }
  const labelNode = <Typography sx={FIELD_LABEL_SX}>{label}</Typography>
  return (
    <Box>
      {tooltip ? (
        <Tooltip placement="top" title={tooltip}>
          {labelNode}
        </Tooltip>
      ) : (
        labelNode
      )}
      <TextField
        fullWidth
        size="small"
        type="text"
        inputMode="decimal"
        value={value ?? ""}
        placeholder={inherited ?? undefined}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        error={error}
        helperText={error ? helperText : ""}
        sx={FIELD_INPUT_SX}
      />
    </Box>
  )
}
